import { IIntegration } from '@amt/i-integration';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-integration-details',
    templateUrl: './integration-details.component.html',
    styleUrls: ['./integration-details.component.scss']
})
export class IntegrationDetailsComponent implements OnInit {
    @Input() integration: IIntegration;

    constructor () { }

    ngOnInit (): void {
    }

}
